/**
 * Judge.me write-review helper + placement fix.
 *
 * Judge.me often places a full review app-block AFTER related products while
 * our mid-page #judgeme_product_reviews host stays empty (duplicate IDs).
 * We move the real widget into the Customer reviews section and hide leftovers.
 */
(function () {
  var OPEN_RETRY_MS = 300;
  var OPEN_MAX_TRIES = 20;
  var RELOCATE_MAX_TRIES = 60;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function hostEl() {
    // Prefer the widget host inside our theme section (app block or manual snippet)
    var section = reviewsSection();
    if (section) {
      var inSection =
        section.querySelector('#judgeme_product_reviews') ||
        section.querySelector('.jdgm-widget.jdgm-review-widget') ||
        section.querySelector('.product-reviews__app-block') ||
        section.querySelector('.product-reviews__jdgm-widget');
      if (inSection) return inSection;
    }
    return document.getElementById('judgeme_product_reviews');
  }

  function reviewsSection() {
    return $('[data-product-reviews]') || document.getElementById('ProductReviews');
  }

  function scrollToReviews() {
    var el = hostEl() || reviewsSection();
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function isFormVisible() {
    var form = $('.jdgm-form') || $('.jdgm-write-rev-form') || $('[class*="jdgm-form"]');
    if (!form) return false;
    var style = window.getComputedStyle(form);
    return style.display !== 'none' && style.visibility !== 'hidden' && form.offsetParent !== null;
  }

  function reviewCount(node) {
    if (!node) return 0;
    return node.querySelectorAll('.jdgm-rev').length;
  }

  function hasRealReviewContent(node) {
    if (!node) return false;
    if (reviewCount(node) > 0) return true;
    // Summary / histogram without individual rows still counts as “has data”
    if (node.querySelector('.jdgm-histogram, .jdgm-rev-widg__summary, .jdgm-rev-widg__body')) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/based on|review|stars|write a review/i.test(text) && text.length > 15) return true;
    }
    return false;
  }

  function scoreWidget(node, section, host) {
    if (!node || node === host) return -1;
    if (host && host.contains(node) && !hasRealReviewContent(node)) return -1;

    var score = 0;
    score += reviewCount(node) * 20;
    if (node.querySelector('.jdgm-write-rev-link, .jdgm-btn--write-review, [class*="write-rev"]')) score += 5;
    if (node.querySelector('.jdgm-rev-widg__header, .jdgm-histogram, .jdgm-rev-widg__summary')) score += 4;
    if (node.getAttribute('data-number-of-reviews')) {
      score += parseInt(node.getAttribute('data-number-of-reviews'), 10) * 15 || 0;
    }
    if (node.getAttribute('data-average-rating')) score += 3;
    if (node.textContent && node.textContent.trim().length > 30) score += 2;

    // Prefer the Shopify app block Judge.me injects after related products
    if (node.closest('.shopify-app-block, [id*="judge_me"], [id*="judgeme"]')) score += 8;
    if (node.closest('.related-products, product-recommendations')) score -= 10;
    if (section && !section.contains(node)) score += 6;
    if (section && section.contains(node) && hasRealReviewContent(node)) score += 50;

    return score;
  }

  /**
   * Pick the richest Judge.me review node on the page (widget or app block).
   */
  function findBestJudgeMeSource(host, section) {
    var selectors = [
      '.jdgm-rev-widg',
      '.jdgm-widget.jdgm-review-widget',
      '.jdgm-widget[data-widget="review"]',
      '.shopify-app-block [id*="judgeme"]',
      '.shopify-block [id*="judgeme"]',
      '#judgeme_product_reviews',
    ];

    var seen = [];
    var best = null;
    var bestScore = -1;

    selectors.forEach(function (sel) {
      $all(sel).forEach(function (node) {
        if (seen.indexOf(node) !== -1) return;
        seen.push(node);

        // Skip our empty mid-page shell
        if (node === host) return;
        if (host && host.contains(node) && !hasRealReviewContent(node)) return;

        var score = scoreWidget(node, section, host);
        if (score > bestScore) {
          bestScore = score;
          best = node;
        }
      });
    });

    // Prefer moving the outer app-block wrapper when the best node is nested in it
    if (best) {
      var appBlock = best.closest('.shopify-app-block, .shopify-block');
      if (
        appBlock &&
        section &&
        !section.contains(appBlock) &&
        hasRealReviewContent(appBlock)
      ) {
        // Only take the app block if it is primarily Judge.me
        if (
          appBlock.querySelector('.jdgm-rev-widg, .jdgm-widget, [id*="judgeme"]') &&
          appBlock.querySelectorAll('.jdgm-rev-widg, .jdgm-widget').length >= 1
        ) {
          return { node: best, hideRoot: appBlock.closest('.shopify-section') || appBlock };
        }
      }

      var outerWidget = best.closest('.jdgm-widget.jdgm-review-widget, .jdgm-widget[data-widget="review"]');
      if (outerWidget && outerWidget !== host && hasRealReviewContent(outerWidget)) {
        return {
          node: outerWidget.querySelector('.jdgm-rev-widg') || outerWidget,
          hideRoot:
            outerWidget.closest('.shopify-section:not(.section-product-reviews)') ||
            outerWidget.closest('.shopify-app-block') ||
            outerWidget,
        };
      }

      return {
        node: best,
        hideRoot:
          best.closest('.shopify-section:not(.section-product-reviews)') ||
          best.closest('.shopify-app-block') ||
          null,
      };
    }

    return null;
  }

  function hideLeftoverJudgeMe(section, host) {
    // Hide any other Judge.me review widgets still outside our section
    $all(
      '.jdgm-rev-widg, .jdgm-widget.jdgm-review-widget, .jdgm-widget[data-widget="review"], [id="judgeme_product_reviews"]'
    ).forEach(function (node) {
      if (node === host) return;
      if (host && host.contains(node)) return;
      if (section && section.contains(node)) return;

      var root =
        node.closest('.shopify-section:not(.section-product-reviews)') ||
        node.closest('.shopify-app-block') ||
        node;
      if (root) {
        root.style.setProperty('display', 'none', 'important');
        root.setAttribute('data-jdgm-relocated-hidden', 'true');
        root.setAttribute('aria-hidden', 'true');
      }
    });

    // Also hide empty shopify sections that only held Judge.me
    $all('.shopify-section[data-jdgm-relocated-hidden="true"]').forEach(function (sec) {
      sec.style.setProperty('display', 'none', 'important');
    });
  }

  /**
   * Move Judge.me's rendered review widget into our mid-page host.
   * No-op when the Judge.me app block is already inside Customer reviews.
   */
  function relocateJudgeMeWidget() {
    var host = hostEl();
    var section = reviewsSection();
    if (!host || !section) return false;

    // App block / widget already mid-page with content — mark mounted + hide footer dupes
    if (section.contains(host) && hasRealReviewContent(section)) {
      host.classList.add('product-reviews__jdgm-widget--mounted');
      var appBlock = section.querySelector('.product-reviews__app-block');
      if (appBlock) appBlock.classList.add('product-reviews__jdgm-widget--mounted');
      hideEmptyState();
      hideLeftoverJudgeMe(section, host);
      return true;
    }

    // Host already has real reviews — just clean up footer duplicates
    if (hasRealReviewContent(host)) {
      host.classList.add('product-reviews__jdgm-widget--mounted');
      hideEmptyState();
      hideLeftoverJudgeMe(section, host);
      return true;
    }

    var found = findBestJudgeMeSource(host, section);
    if (!found || !found.node) return false;
    if (!hasRealReviewContent(found.node) && reviewCount(found.node) === 0) {
      // Still allow moving a full widget shell with summary text
      var t = (found.node.textContent || '').trim();
      if (t.length < 20) return false;
    }

    // Clear empty shells / placeholders inside host
    while (host.firstChild) host.removeChild(host.firstChild);

    // Prefer moving .jdgm-rev-widg content; fall back to the node itself
    var moveNode = found.node;
    if (moveNode.classList && moveNode.classList.contains('jdgm-legacy-widget-content')) {
      var inner = moveNode.querySelector('.jdgm-rev-widg');
      if (inner) moveNode = inner;
    }

    // If we're taking an outer widget that still wraps a rev-widg, take the rev-widg
    if (
      moveNode.classList &&
      moveNode.classList.contains('jdgm-widget') &&
      moveNode.querySelector('.jdgm-rev-widg')
    ) {
      var revWidg = moveNode.querySelector('.jdgm-rev-widg');
      // Prefer visible/non-legacy structure
      if (revWidg) moveNode = revWidg;
    }

    try {
      host.appendChild(moveNode);
    } catch (err) {
      return false;
    }

    // Unhide if Judge.me left temp hide styles
    host.querySelectorAll('.jdgm-temp-hiding-style').forEach(function (s) {
      if (s.parentNode) s.parentNode.removeChild(s);
    });
    host.querySelectorAll('.jdgm-rev-widg, .jdgm-legacy-widget-content').forEach(function (el) {
      el.style.removeProperty('display');
      if (el.getAttribute('style') === '') el.removeAttribute('style');
    });
    var movedWidg = host.querySelector('.jdgm-rev-widg');
    if (movedWidg) {
      movedWidg.style.setProperty('display', 'block', 'important');
    }
    host.style.setProperty('display', 'block', 'important');

    host.classList.add('product-reviews__jdgm-widget--mounted');
    hideEmptyState();

    if (found.hideRoot && !section.contains(found.hideRoot)) {
      found.hideRoot.style.setProperty('display', 'none', 'important');
      found.hideRoot.setAttribute('data-jdgm-relocated-hidden', 'true');
      found.hideRoot.setAttribute('aria-hidden', 'true');
    }

    hideLeftoverJudgeMe(section, host);
    return hasRealReviewContent(host) || host.childNodes.length > 0;
  }

  function hideEmptyState() {
    var empty = $('[data-reviews-empty]');
    if (!empty) return;
    empty.setAttribute('hidden', 'hidden');
    empty.classList.add('product-reviews__empty--has-data');
  }

  function findJudgeMeWriteControl(productId) {
    var host = hostEl();
    var roots = [];
    if (host) roots.push(host);
    roots.push(document);

    var selectors = [
      '.jdgm-write-rev-link',
      '.jdgm-write-rev-btn',
      'a.jdgm-btn--write-review',
      'button.jdgm-write-rev-link',
      '.jdgm-rev-widg__header a[class*="write"]',
      '.jdgm-widget a[class*="write"]',
      '.jdgm-form',
    ];

    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      for (var i = 0; i < selectors.length; i++) {
        var nodes = $all(selectors[i], root);
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          if (node.hasAttribute('data-reviews-write-cta')) continue;
          if (node.classList && node.classList.contains('product-reviews__write-btn')) continue;
          if (
            productId &&
            node.getAttribute('data-id') &&
            String(node.getAttribute('data-id')) !== String(productId)
          ) {
            continue;
          }
          if (node.classList && node.classList.contains('jdgm-form')) {
            return { type: 'form', node: node };
          }
          return { type: 'button', node: node };
        }
      }
    }
    return null;
  }

  function tryOpenJudgeMe(productId) {
    relocateJudgeMeWidget();
    if (isFormVisible()) return true;

    try {
      if (window.jdgm) {
        if (window.jdgm.customize && typeof window.jdgm.customize.openReviewForm === 'function') {
          window.jdgm.customize.openReviewForm(productId ? { productId: productId } : undefined);
          if (isFormVisible()) return true;
        }
        if (typeof window.jdgm.openReviewForm === 'function') {
          window.jdgm.openReviewForm(productId);
          if (isFormVisible()) return true;
        }
      }
    } catch (err) {
      /* continue */
    }

    var found = findJudgeMeWriteControl(productId);
    if (found) {
      if (found.type === 'form') {
        found.node.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
      try {
        found.node.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      } catch (e2) {
        found.node.click();
      }
      return true;
    }
    return false;
  }

  function scheduleOpen(productId) {
    scrollToReviews();
    relocateJudgeMeWidget();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      tryOpenJudgeMe(productId);
      if (isFormVisible() || tries >= OPEN_MAX_TRIES) {
        clearInterval(timer);
      }
    }, OPEN_RETRY_MS);
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest('[data-reviews-write-cta], a.jdgm-write-rev-link, button.jdgm-write-rev-link');
      if (!a) return;

      var inTheme =
        a.closest('[data-product-reviews], [data-product-rating-summary]') ||
        a.hasAttribute('data-reviews-write-cta');
      if (!inTheme) return;

      var productId =
        a.getAttribute('data-id') ||
        (a.closest('[data-product-reviews]') &&
          a.closest('[data-product-reviews]').getAttribute('data-product-id'));

      // Don't preventDefault — Judge.me needs the click when it works natively
      scheduleOpen(productId);
    },
    false
  );

  function startWatchers() {
    var host = hostEl();
    if (!host) return;

    // Keep trying to relocate as Judge.me injects / hydrates the footer app block
    var tries = 0;
    var relocateTimer = setInterval(function () {
      tries += 1;
      var ok = relocateJudgeMeWidget();
      if ((ok && hasRealReviewContent(hostEl())) || tries > RELOCATE_MAX_TRIES) {
        clearInterval(relocateTimer);
        // One more pass after Judge.me finishes hydrating
        if (ok) {
          setTimeout(function () {
            relocateJudgeMeWidget();
            hideLeftoverJudgeMe(reviewsSection(), hostEl());
          }, 800);
        }
      }
    }, 350);

    var moTimer = null;
    new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () {
        moTimer = null;
        relocateJudgeMeWidget();
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      try {
        if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
          window.jdgm.initializeWidgets();
        }
      } catch (e) {
        /* ignore */
      }
      relocateJudgeMeWidget();
    }, 1200);

    // Late pass — Judge.me sometimes hydrates after 2–3s
    setTimeout(function () {
      relocateJudgeMeWidget();
      hideLeftoverJudgeMe(reviewsSection(), hostEl());
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatchers);
  } else {
    startWatchers();
  }
})();
